const REST_API_KEY = "53708d3230fd56e8862d265782d9b693"
const REDIRECT_URI = "https://crm.amazingticket.site/kakao"

export {REST_API_KEY, REDIRECT_URI}